<template>
  <div id="app" :class="{ '-signed-out': !signedIn }">
    <div v-if="signedIn" class="side-nav">
      <h3 class="site-logo">Ripley Chat</h3>

      <ul class="-chevrons">
        <li>
          <router-link to="/dashboard"><i class="ico -dashboard"></i><span>Dashboard</span></router-link>
        </li>
        <li>
          <router-link to="/conversations"><i class="ico -conversations"></i><span>Conversations</span></router-link>
        </li>
        <li>
          <router-link to="/categories"><i class="ico -categories"></i><span>Categories</span></router-link>
        </li>
        <li>
          <router-link to="/queries"><i class="ico -queries"></i><span>Queries</span></router-link>
        </li>
        <li>
          <router-link to="/training"><i class="ico -training"></i><span>Training</span></router-link>
        </li>
        <li>
          <router-link to="/dealerships"><i class="ico -dealerships"></i><span>Dealerships</span></router-link>
        </li>
        <li>
          <router-link to="/webhooks"><i class="ico -webhooks"></i><span>Webhooks</span></router-link>
        </li>
        <li>
          <router-link to="/settings"><i class="ico -settings"></i><span>Settings</span></router-link>
        </li>
        <li>
          <router-link to="/reports"><i class="svg -calendar"></i><span>Reports</span></router-link>
        </li>
        <li v-if="isAdmin">
          <router-link to="/wrongcfgevents"><i class="ico -problem"></i><span>Problems</span></router-link>
        </li>
      </ul>

      <div v-if="currentUser" class="account-info">
        <transition name="slide-fade">
          <ul v-if="accountSectionVisible">
            <li>
              <router-link v-if="currentUser.teams.length > 1" to="/teams"
                ><i class="ico -switchteam"></i><span>Switch teams</span></router-link
              >
            </li>
            <li>
              <a href="#" @click.prevent="signOut"><i class="ico -signout"></i><span>Sign out</span></a>
            </li>
          </ul>
        </transition>
        <span
          class="account-btn"
          :class="{ '-active': accountSectionVisible }"
          @click="accountSectionVisible = !accountSectionVisible"
        >
          <i class="ico -avatar"></i>
          <span class="user-name">{{ currentUser.name }}</span>
          <span class="team-name">{{ currentTeam.name }}</span>
        </span>
      </div>
    </div>

    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

  import "@/styles/application.scss";

  import { mapGetters } from "vuex";

  import api from "@/helpers/api";

  export default {
    data() {
      return {
        accountSectionVisible: false
      };
    },

    computed: {
      ...mapGetters(["signedIn", "currentUser", "isAdmin", "currentTeam"])
    },

    methods: {
      signOut() {
        api
          .instance()
          .delete("oauth/token")
          .then(() => {
            this.$store.dispatch("signOut");
            this.$router.push("/");
          });
      }
    }
  };
</script>
